import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import {
  createRedirect,
  replaceColorInLottie,
} from '../../../../utility/util/util.service';
import { connect } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import signUp from '../../../../assets/lottie/sign-up.json';
import Lottie from 'lottie-react';
import { setIsSignUpNoticeModalOpen } from '../../../../redux/modal/modal.actions';

const SignUpNoticeModal = ({ store, isOpen, setIsSignUpNoticeModalOpen }) => {
  const auth0 = useAuth0();

  const handleRegister = async () => {
    closeModal();
    const guestToken = localStorage.getItem('guestToken');
    if (guestToken) {
      // adopt guest automatically if there is a guestToken
      localStorage.setItem('adoptGuestMode', 'yes');
    }

    await auth0.loginWithPopup({
      screen_hint: 'signup',
      redirectUri: createRedirect(),
    });
  };

  const closeModal = () => setIsSignUpNoticeModalOpen(false);

  return (
    <Modal
      isOpen={isOpen}
      toggle={closeModal}
      className="modal-dialog-centered"
    >
      <ModalHeader
        className="bg-transparent px-1"
        toggle={closeModal}
      ></ModalHeader>
      <ModalBody className="text-center px-2 pt-0">
        <div className="d-flex justify-content-center mb-1">
          <Lottie
            style={{ width: '100%', maxWidth: '125px' }}
            animationData={replaceColorInLottie(
              signUp,
              store?.primaryColor || '#22442c',
            )}
            loop
          />
        </div>
        <h3>
          <FormattedMessage id="signUpTitle" />
        </h3>
        <span>
          <FormattedMessage id="signUpDescription" />
        </span>
      </ModalBody>
      <ModalFooter>
        <Button block color="primary" onClick={handleRegister}>
          <FormattedMessage id="signUpButtonLabel" />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  store: state.store.store,
  isOpen: state.modals.isSignUpNoticeModalOpen,
});

export default connect(mapStateToProps, {
  setIsSignUpNoticeModalOpen,
})(SignUpNoticeModal);
